import Vue from 'vue'
import Vuex from 'vuex'
import Meta from 'vue-meta'
import ClientOnly from 'vue-client-only'
import NoSsr from 'vue-no-ssr'
import { createRouter } from './router.js'
import NuxtChild from './components/nuxt-child.js'
import NuxtError from '../layouts/error.vue'
import Nuxt from './components/nuxt.js'
import App from './App.js'
import { setContext, getLocation, getRouteData, normalizeError } from './utils'
import { createStore } from './store.js'

/* Plugins */

import nuxt_plugin_plugin_4bfffd30 from 'nuxt_plugin_plugin_4bfffd30' // Source: ./components/plugin.js (mode: 'all')
import nuxt_plugin_nuxtmq_8bcb1064 from 'nuxt_plugin_nuxtmq_8bcb1064' // Source: ./nuxt-mq.js (mode: 'all')
import nuxt_plugin_recaptcha_1f812896 from 'nuxt_plugin_recaptcha_1f812896' // Source: ./recaptcha.js (mode: 'all')
import nuxt_plugin_axios_525f1f74 from 'nuxt_plugin_axios_525f1f74' // Source: ./axios.js (mode: 'all')
import nuxt_plugin_libmodulepluginclient314ad1a6_52d0290e from 'nuxt_plugin_libmodulepluginclient314ad1a6_52d0290e' // Source: ./lib.module.plugin.client.314ad1a6.js (mode: 'client')
import nuxt_plugin_templatesplugind431ce70_6e3f3f8d from 'nuxt_plugin_templatesplugind431ce70_6e3f3f8d' // Source: ./templates.plugin.d431ce70.js (mode: 'all')
import nuxt_plugin_workbox_3374283c from 'nuxt_plugin_workbox_3374283c' // Source: ./workbox.js (mode: 'client')
import nuxt_plugin_metaplugin_48ee30f5 from 'nuxt_plugin_metaplugin_48ee30f5' // Source: ./pwa/meta.plugin.js (mode: 'all')
import nuxt_plugin_iconplugin_4d95d669 from 'nuxt_plugin_iconplugin_4d95d669' // Source: ./pwa/icon.plugin.js (mode: 'all')
import nuxt_plugin_nuxtplugin79ffe248_0323c6a2 from 'nuxt_plugin_nuxtplugin79ffe248_0323c6a2' // Source: ./nuxt.plugin.79ffe248.js (mode: 'all')
import nuxt_plugin_api_caeae0b4 from 'nuxt_plugin_api_caeae0b4' // Source: ../plugins/api (mode: 'all')
import nuxt_plugin_storyblok_068762a7 from 'nuxt_plugin_storyblok_068762a7' // Source: ../plugins/storyblok (mode: 'all')
import nuxt_plugin_metadata_3ceffd23 from 'nuxt_plugin_metadata_3ceffd23' // Source: ../plugins/metadata (mode: 'all')
import nuxt_plugin_vueaffix_c88c1ef8 from 'nuxt_plugin_vueaffix_c88c1ef8' // Source: ../plugins/vue-affix.client (mode: 'client')
import nuxt_plugin_compositionapi_fa0591fa from 'nuxt_plugin_compositionapi_fa0591fa' // Source: ../plugins/composition-api (mode: 'all')
import nuxt_plugin_richtextrenderer_601869b4 from 'nuxt_plugin_richtextrenderer_601869b4' // Source: ../plugins/rich-text-renderer (mode: 'all')
import nuxt_plugin_toquerystring_3c12cb58 from 'nuxt_plugin_toquerystring_3c12cb58' // Source: ../plugins/to-query-string (mode: 'all')
import nuxt_plugin_vuescrollreveal_87e31432 from 'nuxt_plugin_vuescrollreveal_87e31432' // Source: ../plugins/vue-scroll-reveal.client (mode: 'client')
import nuxt_plugin_vueslickcarousel_756afa10 from 'nuxt_plugin_vueslickcarousel_756afa10' // Source: ../plugins/vue-slick-carousel (mode: 'all')
import nuxt_plugin_vuevideobackground_0ba2e1ca from 'nuxt_plugin_vuevideobackground_0ba2e1ca' // Source: ../plugins/vue-video-background (mode: 'client')
import nuxt_plugin_googlemaps_c54ce192 from 'nuxt_plugin_googlemaps_c54ce192' // Source: ../plugins/google-maps (mode: 'client')
import nuxt_plugin_gtm_caeab2a8 from 'nuxt_plugin_gtm_caeab2a8' // Source: ../plugins/gtm (mode: 'client')
import nuxt_plugin_storage_25489bf2 from 'nuxt_plugin_storage_25489bf2' // Source: ../plugins/storage (mode: 'server')
import nuxt_plugin_gtag_0a2cb1e4 from 'nuxt_plugin_gtag_0a2cb1e4' // Source: ../plugins/gtag.js (mode: 'all')

// Component: <ClientOnly>
Vue.component(ClientOnly.name, ClientOnly)

// TODO: Remove in Nuxt 3: <NoSsr>
Vue.component(NoSsr.name, {
  ...NoSsr,
  render (h, ctx) {
    if (process.client && !NoSsr._warned) {
      NoSsr._warned = true

      console.warn('<no-ssr> has been deprecated and will be removed in Nuxt 3, please use <client-only> instead')
    }
    return NoSsr.render(h, ctx)
  }
})

// Component: <NuxtChild>
Vue.component(NuxtChild.name, NuxtChild)
Vue.component('NChild', NuxtChild)

// Component NuxtLink is imported in server.js or client.js

// Component: <Nuxt>
Vue.component(Nuxt.name, Nuxt)

Object.defineProperty(Vue.prototype, '$nuxt', {
  get() {
    return this.$root.$options.$nuxt
  },
  configurable: true
})

Vue.use(Meta, {"keyName":"head","attribute":"data-n-head","ssrAttribute":"data-n-head-ssr","tagIDKeyName":"hid"})

const defaultTransition = {"name":"page","mode":"out-in","appear":false,"appearClass":"appear","appearActiveClass":"appear-active","appearToClass":"appear-to"}

const originalRegisterModule = Vuex.Store.prototype.registerModule
const baseStoreOptions = { preserveState: process.client }

function registerModule (path, rawModule, options = {}) {
  return originalRegisterModule.call(this, path, rawModule, { ...baseStoreOptions, ...options })
}

async function createApp(ssrContext, config = {}) {
  const router = await createRouter(ssrContext)

  const store = createStore(ssrContext)
  // Add this.$router into store actions/mutations
  store.$router = router

  // Fix SSR caveat https://github.com/nuxt/nuxt.js/issues/3757#issuecomment-414689141
  store.registerModule = registerModule

  // Create Root instance

  // here we inject the router and store to all child components,
  // making them available everywhere as `this.$router` and `this.$store`.
  const app = {
    head: {"titleTemplate":"%s | Perkins American Food Co.","title":"Perkins American Food Co.","meta":[{"charset":"utf-8"},{"name":"viewport","content":"width=device-width, initial-scale=1"},{"hid":"description","name":"description","content":"Perkins American Food Co."},{"hid":"og:site_name","name":"og:site_name","content":"Perkins American Food Co."},{"name":"theme_color","content":"#2B5449"},{"hid":"og:description","name":"og:description","content":"Perkins American Food Co."},{"hid":"apple-mobile-web-app-title","name":"apple-mobile-web-app-title","content":"Perkins American Food Co."}],"link":[{"rel":"icon","type":"image\u002Fx-icon","href":"\u002Ffavicon.ico"},{"rel":"stylesheet preload prefetch","type":"text\u002Fcss","crossorigin":"anonymous","as":"style","href":"https:\u002F\u002Fuse.typekit.net\u002Febc5yzx.css"},{"rel":"stylesheet preload prefetch","href":"https:\u002F\u002Ffonts.googleapis.com\u002Fcss2?family=Roboto+Condensed:ital,wght@0,100..900;1,100..900&display=swap"}],"script":[{"hid":"yelp_tracking_pixel","innerHTML":"\n            adroll_adv_id = \"WE2M7KSM25G2TENYI5ZDYA\";\n            adroll_pix_id = \"NV4TTY5XXNE73JYCGLVUEM\";\n            adroll_version = \"2.0\";\n\n            (function (w, d, e, o, a) {\n                w.__adroll_loaded = true;\n                w.adroll = w.adroll || [];\n                w.adroll.f = [ 'setProperties', 'identify', 'track', 'identify_email' ];\n                var roundtripUrl = \"https:\u002F\u002Fs.adroll.com\u002Fj\u002F\" + adroll_adv_id\n                        + \"\u002Froundtrip.js\";\n                for (a = 0; a \u003C w.adroll.f.length; a++) {\n                    w.adroll[w.adroll.f[a]] = w.adroll[w.adroll.f[a]] || (function(n) {\n                        return function() {\n                            w.adroll.push([ n, arguments ])\n                        }\n                    })(w.adroll.f[a])\n                }\n\n                e = d.createElement('script');\n                o = d.getElementsByTagName('script')[0];\n                e.async = 1;\n                e.src = roundtripUrl;\n                o.parentNode.insertBefore(e, o);\n            })(window, document);\n            adroll.track(\"pageView\");\n            ","type":"text\u002Fjavascript","charset":"utf-8"},{"hid":"ms_clarity","innerHTML":"\n          (function(c,l,a,r,i,t,y){\nc[a]=c[a]||function(){(c[a].q=c[a].q||[]).push(arguments)};\nt=l.createElement(r);t.async=1;t.src=\"https:\u002F\u002Fwww.clarity.ms\u002Ftag\u002F\"+i;\ny=l.getElementsByTagName(r)[0];y.parentNode.insertBefore(t,y);\n})(window, document, \"clarity\", \"script\", \"pwvyn30yy4\");\n          ","type":"text\u002Fjavascript","charset":"utf-8"}],"__dangerouslyDisableSanitizers":["script"],"style":[]},

    store,
    router,
    nuxt: {
      defaultTransition,
      transitions: [defaultTransition],
      setTransitions (transitions) {
        if (!Array.isArray(transitions)) {
          transitions = [transitions]
        }
        transitions = transitions.map((transition) => {
          if (!transition) {
            transition = defaultTransition
          } else if (typeof transition === 'string') {
            transition = Object.assign({}, defaultTransition, { name: transition })
          } else {
            transition = Object.assign({}, defaultTransition, transition)
          }
          return transition
        })
        this.$options.nuxt.transitions = transitions
        return transitions
      },

      err: null,
      dateErr: null,
      error (err) {
        err = err || null
        app.context._errored = Boolean(err)
        err = err ? normalizeError(err) : null
        let nuxt = app.nuxt // to work with @vue/composition-api, see https://github.com/nuxt/nuxt.js/issues/6517#issuecomment-573280207
        if (this) {
          nuxt = this.nuxt || this.$options.nuxt
        }
        nuxt.dateErr = Date.now()
        nuxt.err = err
        // Used in src/server.js
        if (ssrContext) {
          ssrContext.nuxt.error = err
        }
        return err
      }
    },
    ...App
  }

  // Make app available into store via this.app
  store.app = app

  const next = ssrContext ? ssrContext.next : location => app.router.push(location)
  // Resolve route
  let route
  if (ssrContext) {
    route = router.resolve(ssrContext.url).route
  } else {
    const path = getLocation(router.options.base, router.options.mode)
    route = router.resolve(path).route
  }

  // Set context to app.context
  await setContext(app, {
    store,
    route,
    next,
    error: app.nuxt.error.bind(app),
    payload: ssrContext ? ssrContext.payload : undefined,
    req: ssrContext ? ssrContext.req : undefined,
    res: ssrContext ? ssrContext.res : undefined,
    beforeRenderFns: ssrContext ? ssrContext.beforeRenderFns : undefined,
    ssrContext
  })

  function inject(key, value) {
    if (!key) {
      throw new Error('inject(key, value) has no key provided')
    }
    if (value === undefined) {
      throw new Error(`inject('${key}', value) has no value provided`)
    }

    key = '$' + key
    // Add into app
    app[key] = value
    // Add into context
    if (!app.context[key]) {
      app.context[key] = value
    }

    // Add into store
    store[key] = app[key]

    // Check if plugin not already installed
    const installKey = '__nuxt_' + key + '_installed__'
    if (Vue[installKey]) {
      return
    }
    Vue[installKey] = true
    // Call Vue.use() to install the plugin into vm
    Vue.use(() => {
      if (!Object.prototype.hasOwnProperty.call(Vue.prototype, key)) {
        Object.defineProperty(Vue.prototype, key, {
          get () {
            return this.$root.$options[key]
          }
        })
      }
    })
  }

  // Inject runtime config as $config
  inject('config', config)

  if (process.client) {
    // Replace store state before plugins execution
    if (window.__NUXT__ && window.__NUXT__.state) {
      store.replaceState(window.__NUXT__.state)
    }
  }

  // Add enablePreview(previewData = {}) in context for plugins
  if (process.static && process.client) {
    app.context.enablePreview = function (previewData = {}) {
      app.previewData = Object.assign({}, previewData)
      inject('preview', previewData)
    }
  }
  // Plugin execution

  if (typeof nuxt_plugin_plugin_4bfffd30 === 'function') {
    await nuxt_plugin_plugin_4bfffd30(app.context, inject)
  }

  if (typeof nuxt_plugin_nuxtmq_8bcb1064 === 'function') {
    await nuxt_plugin_nuxtmq_8bcb1064(app.context, inject)
  }

  if (typeof nuxt_plugin_recaptcha_1f812896 === 'function') {
    await nuxt_plugin_recaptcha_1f812896(app.context, inject)
  }

  if (typeof nuxt_plugin_axios_525f1f74 === 'function') {
    await nuxt_plugin_axios_525f1f74(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_libmodulepluginclient314ad1a6_52d0290e === 'function') {
    await nuxt_plugin_libmodulepluginclient314ad1a6_52d0290e(app.context, inject)
  }

  if (typeof nuxt_plugin_templatesplugind431ce70_6e3f3f8d === 'function') {
    await nuxt_plugin_templatesplugind431ce70_6e3f3f8d(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_workbox_3374283c === 'function') {
    await nuxt_plugin_workbox_3374283c(app.context, inject)
  }

  if (typeof nuxt_plugin_metaplugin_48ee30f5 === 'function') {
    await nuxt_plugin_metaplugin_48ee30f5(app.context, inject)
  }

  if (typeof nuxt_plugin_iconplugin_4d95d669 === 'function') {
    await nuxt_plugin_iconplugin_4d95d669(app.context, inject)
  }

  if (typeof nuxt_plugin_nuxtplugin79ffe248_0323c6a2 === 'function') {
    await nuxt_plugin_nuxtplugin79ffe248_0323c6a2(app.context, inject)
  }

  if (typeof nuxt_plugin_api_caeae0b4 === 'function') {
    await nuxt_plugin_api_caeae0b4(app.context, inject)
  }

  if (typeof nuxt_plugin_storyblok_068762a7 === 'function') {
    await nuxt_plugin_storyblok_068762a7(app.context, inject)
  }

  if (typeof nuxt_plugin_metadata_3ceffd23 === 'function') {
    await nuxt_plugin_metadata_3ceffd23(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_vueaffix_c88c1ef8 === 'function') {
    await nuxt_plugin_vueaffix_c88c1ef8(app.context, inject)
  }

  if (typeof nuxt_plugin_compositionapi_fa0591fa === 'function') {
    await nuxt_plugin_compositionapi_fa0591fa(app.context, inject)
  }

  if (typeof nuxt_plugin_richtextrenderer_601869b4 === 'function') {
    await nuxt_plugin_richtextrenderer_601869b4(app.context, inject)
  }

  if (typeof nuxt_plugin_toquerystring_3c12cb58 === 'function') {
    await nuxt_plugin_toquerystring_3c12cb58(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_vuescrollreveal_87e31432 === 'function') {
    await nuxt_plugin_vuescrollreveal_87e31432(app.context, inject)
  }

  if (typeof nuxt_plugin_vueslickcarousel_756afa10 === 'function') {
    await nuxt_plugin_vueslickcarousel_756afa10(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_vuevideobackground_0ba2e1ca === 'function') {
    await nuxt_plugin_vuevideobackground_0ba2e1ca(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_googlemaps_c54ce192 === 'function') {
    await nuxt_plugin_googlemaps_c54ce192(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_gtm_caeab2a8 === 'function') {
    await nuxt_plugin_gtm_caeab2a8(app.context, inject)
  }

  if (process.server && typeof nuxt_plugin_storage_25489bf2 === 'function') {
    await nuxt_plugin_storage_25489bf2(app.context, inject)
  }

  if (typeof nuxt_plugin_gtag_0a2cb1e4 === 'function') {
    await nuxt_plugin_gtag_0a2cb1e4(app.context, inject)
  }

  // Lock enablePreview in context
  if (process.static && process.client) {
    app.context.enablePreview = function () {
      console.warn('You cannot call enablePreview() outside a plugin.')
    }
  }

  // If server-side, wait for async component to be resolved first
  if (process.server && ssrContext && ssrContext.url) {
    await new Promise((resolve, reject) => {
      router.push(ssrContext.url, resolve, (err) => {
        // https://github.com/vuejs/vue-router/blob/v3.4.3/src/util/errors.js
        if (!err._isRouter) return reject(err)
        if (err.type !== 2 /* NavigationFailureType.redirected */) return resolve()

        // navigated to a different route in router guard
        const unregister = router.afterEach(async (to, from) => {
          ssrContext.url = to.fullPath
          app.context.route = await getRouteData(to)
          app.context.params = to.params || {}
          app.context.query = to.query || {}
          unregister()
          resolve()
        })
      })
    })
  }

  return {
    store,
    app,
    router
  }
}

export { createApp, NuxtError }
